import { useI18n } from '../../i18n.js';

export function LandingFeatures() {
  const { lang, t } = useI18n();
  const isMn = lang === 'mn';

  return (
    <section className="landing-section" id="features" aria-label={t.landingFeaturesTitle}>
      <div className="landing-section-header">
        <h2>{t.landingFeaturesTitle}</h2>
        <p>{t.landingFeaturesSubtitle}</p>
      </div>

      <div className="features-grid">
        <div className="feature-card">
          <span className="feature-suit-mark" aria-hidden="true">♠</span>
          <div className="feature-body">
            <h3 className="feature-title">{isMn ? 'Шууд Хөтчөөсөө Тоглох' : 'Instant Web Play'}</h3>
            <p className="feature-desc">
              {isMn
                ? 'Ямар ч апп таталгүйгээр утас, компьютерын хөтчөөс шууд тоглоно.'
                : 'Zero downloads. Open your browser on phone or PC and start in seconds.'}
            </p>
          </div>
        </div>

        <div className="feature-card">
          <span className="feature-suit-mark" aria-hidden="true">♣</span>
          <div className="feature-body">
            <h3 className="feature-title">{isMn ? 'Ухаалаг Ботууд' : 'Smart Bots'}</h3>
            <p className="feature-desc">
              {isMn
                ? 'Хүн хүлээх шаардлагагүй, 24/7 ухаалаг ботуудтай хүссэн үедээ тоглоно.'
                : 'Play anytime without waiting. Tactical bots keep the action moving.'}
            </p>
          </div>
        </div>

        <div className="feature-card">
          <span className="feature-suit-mark is-red" aria-hidden="true">♦</span>
          <div className="feature-body">
            <h3 className="feature-title">{isMn ? 'Хувийн ба Нээлттэй Өрөө' : 'Private & Public Rooms'}</h3>
            <p className="feature-desc">
              {isMn
                ? '4 оронтой кодоор найзуудаа урих эсвэл нээлттэй өрөөнд нэгдэнэ.'
                : 'Host private matches with a 4-letter code, or join public rooms.'}
            </p>
          </div>
        </div>

        <div className="feature-card">
          <span className="feature-suit-mark is-red" aria-hidden="true">♥</span>
          <div className="feature-body">
            <h3 className="feature-title">{isMn ? 'Цай Онооны Эдийн Засаг' : 'Virtual Tsai Economy'}</h3>
            <p className="feature-desc">
              {isMn
                ? 'Бүртгэлд 100 Цай үнэгүй бөгөөд 7 хоног бүрийн урамшуулалтай.'
                : 'Claim 100 free tokens on sign-up, plus recurring weekly refills.'}
            </p>
          </div>
        </div>

        <div className="feature-card">
          <span className="feature-suit-mark is-gold" aria-hidden="true">★</span>
          <div className="feature-body">
            <h3 className="feature-title">{isMn ? 'VIP ба Тансаг Хөзрийн Ар' : 'VIP Customization & Styles'}</h3>
            <p className="feature-desc">
              {isMn
                ? 'Тусгай нэртэй өрөө, дуут яриа (Voice chat) болон тансаг хөзрийн ар.'
                : 'Vanity room names, live in-room voice chat, and luxury card backs.'}
            </p>
          </div>
        </div>

        <div className="feature-card">
          <span className="feature-suit-mark is-gold" aria-hidden="true">❖</span>
          <div className="feature-body">
            <h3 className="feature-title">{isMn ? 'Шударга, Нууцлалтай Сервер' : 'Authoritative & Fair Play'}</h3>
            <p className="feature-desc">
              {isMn
                ? 'Бүх дүрэм сервер дээр 100% шударга, нууцлалтайгаар тооцогдоно.'
                : 'Server-side rules engine with zero-knowledge card dealing. 100% fair.'}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
